import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.DARK_GREEN,
    mapProp: 'map',
    name: '数据库实例',
    ownerIdProp: 'dbId',
    ownerTextProp: 'dbName',
    ownerType: 'DB',
    textProp: 'dbInsName',
    type: 'DBINS',
}

